module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/accounts.component.scss
// module id = ./src/app/accounts/accounts.component.scss
// module chunks = main